import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel, FormatterUtils } from '../core/index';
import { HotelBedCatalogData, HotelBedData, BookingData } from 'src/shared';
import { getAjaxhelper, momentDuration, momentWrapper } from 'src/utils';
import * as  moment from 'moment';
export interface BookingRightPanelProps extends BaseComponentProps {
    bookingData: HotelBedCatalogData.Hotel;
    currencyCode: string;
    collapse: boolean;
    totalValue: number;
    updateCoupon: (adaCupon: boolean, discountName: string, totalDisc: number, couponCode: string) => any;
    oneDolar: boolean;
}

export interface BookingRightPanelState extends BaseComponentState {

    cuponCode: string;
    cuponError: any;
    adaCupon: boolean;
    classCupon: string;
    discountName: string;
    totalDisc: number; 
}

export class BookingRightPanel extends BaseComponent<BookingRightPanelProps, BookingRightPanelState> {
    constructor(props: BookingRightPanelProps) {
        super(props);
        this.state = {
            cuponCode: '',
            cuponError: '', adaCupon: false, classCupon: '', discountName: '', totalDisc: 0 
        };
    }
    render() {
        let rightPanel: any[] = [];
        let isiBookingSummary: any[] = [];
        let jumlahHari = 0;
        if (this.props.bookingData.bookingSumary) {
            isiBookingSummary.push(
                <p>
                    <span>Check In Date:</span>
                    <span style={{ float: 'right' }}>{this.props.bookingData.bookingSumary!.checkIn}</span>
                </p>
            );
            isiBookingSummary.push(
                <p>
                    <span>Check Out Date:</span>
                    <span style={{ float: 'right' }}>{this.props.bookingData.bookingSumary!.checkOut}</span>
                </p>
            );
            let stdt = moment(this.props.bookingData.bookingSumary!.checkIn);
            let endt = moment(this.props.bookingData.bookingSumary!.checkOut);
            jumlahHari = momentDuration(endt.diff(stdt)).as('day');
            isiBookingSummary.push(
                <p>
                    <span>Number Of Night/s:</span>
                    <span style={{ float: 'right' }}>{jumlahHari} Night</span>
                </p>
            );
        }
        let isiRoomSelected: any[] = [];
        let isiCancelationPolicy: any[] = [];
        if (this.props.bookingData.roomData) {
            if (this.props.bookingData.roomData.roomNo) {
                isiBookingSummary.push(
                    <p>
                        <span>Number of Room/s:</span>
                        <span style={{ float: 'right' }}>{this.props.bookingData.roomData.roomNo}</span>
                    </p>
                );
            }
            if (this.props.bookingData.roomData.adults) {
                isiBookingSummary.push(
                    <p>
                        <span>Number Of Passenger/s :</span>
                        <span style={{ float: 'right' }}>{this.props.bookingData.roomData.adults + this.props.bookingData.roomData.children!}</span>
                    </p>
                );
            }
            let lop2 = 0;
            if (this.props.bookingData.roomData.rateDetail) {
                let jumKamar = Object.keys(this.props.bookingData.roomData.rateDetail).length;
                for (let room of Object.keys(this.props.bookingData.roomData.rateDetail)) {
                    lop2++;
                    let marginBtnAkhir = '5px';
                    if (lop2 !== jumKamar) {
                        marginBtnAkhir = '25px';
                    }
                    let rDetail: { jumlah: number, rates: HotelBedData.Rate[], roomFullCode: string, roomName: string } = this.props.bookingData.roomData.rateDetail[room];
                    let kali = "";
                    if (rDetail.jumlah > 1) {
                        kali = `${rDetail.jumlah} x `;
                    }
                    isiRoomSelected.push(
                        <p
                            style={
                                {
                                    textTransform: "capitalize",
                                    background: "rgb(169, 171, 208)",
                                    margin: "-15px -15px 10px",
                                    padding: "15px",
                                    color: "rgb(255, 255, 255)"
                                }}
                        > <strong>{kali} {rDetail.roomName}</strong>
                        </p>
                    );
                    isiCancelationPolicy.push(
                        <p
                            style={
                                {
                                    textTransform: "capitalize",
                                    background: "rgb(238, 238, 238)",
                                    margin: "-15px -15px 10px",
                                    padding: "15px",
                                    color: "rgb(107, 107, 107)"
                                }}
                        > <strong>{kali} {rDetail.roomName}</strong>
                        </p>
                    );

                    let lop = 0;
                    for (let rate of rDetail.rates) {
                        if (lop > 0) {
                            isiRoomSelected.push(
                                <p style={{ marginBottom: '5px' }}>
                                    <hr style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }} />
                                </p>
                            );
                            isiCancelationPolicy.push(
                                <p style={{ marginBottom: '5px' }}>
                                    <hr style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }} />
                                </p>
                            );
                        }
                        if (rate.cancellationPolicies) {
                            let jumPolicy = rate.cancellationPolicies.length;
                            let cancelmarginBottom = '5px';
                            let lop3 = 0;
                            for (let cancel of rate.cancellationPolicies) {
                                lop3++;
                                if (jumPolicy === lop3 && lop2 !== jumKamar) {
                                    cancelmarginBottom = '25px';
                                }
                                isiCancelationPolicy.push(
                                    <p style={{ marginBottom: cancelmarginBottom }}>
                                        <span> From {moment(cancel.from).format("DD-MM-YYYY")} </span>
                                        <span style={{ float: 'right' }}>{new FormatterUtils().formatMoney(cancel.amount! * rate.jumlah!, this.props.currencyCode!, true)}</span>
                                    </p>
                                );
                            }
                        }
                        let diskon = 0;
                        let diskonSatuan = 0;
                        let diskonname = "";
                        if (rate.offers) {
                            for (let offer of rate.offers) {
                                if (diskon > (offer.amount! * rate.jumlah!)) {
                                    diskon = offer.amount! * rate.jumlah!;
                                    diskonname = offer.name!;
                                    diskonSatuan = offer.amount!;
                                }
                            }
                        }
                        isiRoomSelected.push(
                            <p style={{ marginBottom: '5px' }}> {rate.rooms! * rate.jumlah!} <i className="fa fa-bed" /> {rate.adults! * rate.jumlah!} <i className="fa fa-user" /> {rate.children! * rate.jumlah!} <i className="fa fa-child" /> ( {rate.boardName})
                            </p>
                        );
                        isiRoomSelected.push(
                            <p style={{ marginBottom: '5px' }}>
                                <span>Price/Room/Night </span>
                                <span style={{ float: 'right' }}>{new FormatterUtils().formatMoney((rate.net! - diskonSatuan) / jumlahHari, this.props.currencyCode!, true)}</span>
                            </p>
                        );
                        isiRoomSelected.push(
                            <p style={{ marginBottom: '5px' }}>
                                <span>Number Of Room/s </span>
                                <span style={{ float: 'right' }}> {rate.jumlah}</span>
                            </p>
                        );
                        isiRoomSelected.push(
                            <p style={{ marginBottom: '5px' }}>
                                <span>Number Of Night/s </span>
                                <span style={{ float: 'right' }}> {jumlahHari}</span>
                            </p>
                        );
                        isiRoomSelected.push(
                            <p style={{ marginBottom: '5px' }}>
                                <hr style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }} />
                            </p>
                        );
                        if (diskon !== 0) {
                            isiRoomSelected.push(
                                <p style={{ marginBottom: '5px' }}>
                                    <span>Before Discount </span>
                                    <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(((rate.net! * rate.jumlah!) - diskon), this.props.currencyCode, true)}</span>
                                </p>
                            );
                            isiRoomSelected.push(
                                <p style={{ marginBottom: '5px', color: 'red' }}>
                                    <span> {diskonname} </span>
                                    <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(diskon, this.props.currencyCode, true)}</span>
                                </p>
                            );
                            isiRoomSelected.push(
                                <p style={{ marginBottom: '5px' }}>
                                    <hr style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }} />
                                </p>
                            );
                            isiRoomSelected.push(
                                <p style={{ marginBottom: marginBtnAkhir, fontWeight: 800 }}>
                                    <span> After Discount </span>
                                    <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(rate.net! * rate.jumlah!, this.props.currencyCode, true)}</span>
                                </p>
                            );
                        } else {
                            isiRoomSelected.push(
                                <p style={{ marginBottom: marginBtnAkhir, fontWeight: 800 }}>
                                    <span> Sub Total </span>
                                    <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(rate.net! * rate.jumlah!, this.props.currencyCode, true)}</span>
                                </p>
                            );
                        }

                        lop++;
                    }
                }
                if (!this.state.adaCupon) {
                    isiRoomSelected.push(
                        <div
                            className="row margin-top-5 "
                            style={
                                {
                                    color: "rgb(255, 255, 255)",
                                    fontSize: 14,
                                    fontWeight: 800,
                                    background: "rgb(46, 143, 255)",
                                    padding: "15px 0px",
                                    marginBottom: "-15px"
                                }}
                        >
                            <p style={{ padding: '0px 15px' }}>
                                <span> Booking Total  </span>
                                <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(this.props.bookingData.roomData.net!, this.props.currencyCode, true)}</span>
                            </p>
                        </div>
                    );
                } else {
                    isiRoomSelected.push(
                        <p style={{ marginBottom: '5px' }}>
                            <hr style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }} />
                        </p>
                    );
                    isiRoomSelected.push(
                        <div className='row margin-top-5 ' style={{ padding: '5px 0 25px', marginBottom: -15 }}>
                            <div className="col-md-6" style={{color: 'green', fontWeight: 800}}> Coupon Discount ({this.state.discountName}) </div>
                            <div className="col-md-6" style={{ textAlign: 'right', color: 'red', fontWeight: 800 }}>{new FormatterUtils().formatMoney(this.state.totalDisc * -1, this.props.currencyCode, true, false)}</div>
                        </div>
                    );
                    isiRoomSelected.push(
                        <div
                            className="row margin-top-5 "
                            style={
                                {
                                    color: "rgb(255, 255, 255)",
                                    fontSize: 14,
                                    fontWeight: 800,
                                    background: "rgb(46, 143, 255)",
                                    padding: "15px 0px",
                                    marginBottom: "-15px"
                                }}
                        >
                            <p style={{ padding: '0px 15px' }}>
                                <span> Booking Total  </span>
                                <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney(this.props.totalValue - this.state.totalDisc, this.props.currencyCode, true)}</span>
                            </p>
                        </div>
                    );
                }
                if (this.props.oneDolar) {
                    isiRoomSelected.push(
                        <div
                            className="row margin-top-5 "
                            style={
                                {
                                    color: "rgb(255, 255, 255)",
                                    fontSize: 14,
                                    fontWeight: 800,
                                    background: "rgb(46, 143, 255)",
                                    padding: "15px 0px",
                                    marginBottom: "-15px"
                                }}
                        >
                            <p style={{ padding: '0px 15px' }}>
                                <span> Total Due Today  </span>
                                <span style={{ float: 'right' }}> {new FormatterUtils().formatMoney( 1, this.props.currencyCode, true)}</span>
                            </p>
                        </div>
                    );
                    isiRoomSelected.push(
                        <div
                            className="row margin-top-5 "
                            style={
                                {
                                    color: "rgb(255, 255, 255)",
                                    fontSize: 14,
                                    fontWeight: 800,
                                    background: "#f0ad4e",
                                    padding: "15px 0px",
                                    marginBottom: "-15px"
                                }}
                        >
                            <p style={{ padding: '0px 15px' }}>
                                <ul>
                                    <li>Book This Room For $1 Deposit - Available Now</li>
                                    <li>Pay Balance 14 Days Before Arrival*</li>
                                    <li>Reserve Your Room Now </li>
                                    <li>Free Cancelation </li>                                    
                                </ul>
                            </p>
                        </div>
                    );
                }
            }
        }
        let errCup = <span />;
        if ((this.state.cuponError && this.state.cuponError.length !== 0)) {
            errCup = <span className="alert alert-danger" style={{ display: 'block', marginBottom: 0 }}> {this.state.cuponError}</span>;
        }
        let componentCupon = (
            <div>
                <input
                    type='text'
                    value={this.state.cuponCode}
                    onChange={
                        evt => {
                            let cup = evt.target.value;
                            this.setState({ cuponCode: cup });
                        }
                    }
                />
                {errCup}
                <button
                    className="btn btn-primary form-control"
                    onClick={
                        () => {
                            getAjaxhelper().get(`/dynamics/rest-api/generic/CouponCode/${this.state.cuponCode}`).then(
                                (d: BookingData.CouponCode) => {
                                    let bisaPake = 0;
                                    if ((d)) {
                                        let date = momentWrapper(new Date);
                                        let startDate = momentWrapper(d.startDate);
                                        let endDate = momentWrapper('3000-12-31');
                                        let hotelError = false;
                                        if ((d.endDate)) {
                                            endDate = momentWrapper(d.endDate);
                                        }
                                        if ((d.hotelCodes)) {
                                            let htCodes = JSON.parse(d.hotelCodes!);
                                            let masuk = 0;
                                            for (let htcode of htCodes) {
                                                if (htcode === this.props.bookingData.code) {
                                                    masuk = 1;
                                                }
                                            }
                                            if (masuk === 0) {
                                                hotelError = true;
                                                this.setState({ cuponError: `Coupon Code can use by selected Hotel` });
                                            }
                                        }
                                        if (date.isBefore(endDate) && date.isAfter(startDate) || (date.isSame(startDate) || date.isSame(endDate))) {
                                            if ((d.maximum)) {
                                                let used: number = 0;
                                                if ((d.usedCount)) {
                                                    used = d.usedCount!;
                                                }
                                                if (used >= d.maximum!) {
                                                    this.setState({ cuponError: `Coupon Code is limited, maximum used only ${d.maximum}` });
                                                } else {
                                                    if (hotelError === false) {
                                                        bisaPake = 1;
                                                    }
                                                }
                                            } else {
                                                if (hotelError === false) {
                                                    bisaPake = 1;
                                                }
                                            }
                                        } else {
                                            if (date.isBefore(startDate)) {
                                                this.setState({ cuponError: `Coupon Code can use From ${startDate.format('MMM Do YY')}` });
                                            } else {
                                                if (date.isAfter(endDate)) {
                                                    this.setState({ cuponError: `Coupon Code can use until ${endDate.format('MMM Do YY')}` });
                                                } else {
                                                    this.setState({ cuponError: `Coupon Code can't use on this transaction` });
                                                }
                                            }
                                        }
                                    } else {
                                        this.setState({ cuponError: 'Coupon Code is Not found' });
                                    }
                                    if (bisaPake === 1) {
                                        let totalDisc = this.props.totalValue * d.discValue! / 100;
                                        this.setStateHelper(
                                            st => {
                                                st.adaCupon = true;
                                                st.classCupon = 'hide';
                                                st.discountName = d.name!;
                                                st.totalDisc = totalDisc; 
                                            },
                                            () => {
                                                this.props.updateCoupon(this.state.adaCupon, this.state.discountName, this.state.totalDisc, this.state.cuponCode);
                                                // this.props.totalValue(this.state.totalValue);
                                                // this.props.haveCoupon(d.code!, d.discValue!, this.state.totalValueAsli - this.state.totalValue, this.state.totalValueAsli );
                                            }
                                        );
                                    }
                                }
                            ).catch(exc => {
                                console.log(exc);
                            });
                        }
                    }
                >Use Code
                </button>
            </div >
        );

        let bookingSummary = <div>{isiBookingSummary}</div>;
        rightPanel.push(
            <ColapsePanel
                title="Booking Summary"
                colapse={this.props.collapse}
                component={bookingSummary}
            />
        );

        let roomSelected = <div>{isiRoomSelected}</div>;
        rightPanel.push(
            <ColapsePanel
                title="Room/s Selected"
                colapse={this.props.collapse}
                component={roomSelected}
            />
        );

        rightPanel.push(
            <ColapsePanel
                colapse={true}
                title='Enter Coupon Code'
                component={componentCupon}
                className={this.state.classCupon}
            />
        );
        rightPanel.push(
            <ColapsePanel
                title="Booking Inclusions"
                colapse={this.props.collapse}
                component={
                    <ul>
                        <li>All Tax And Service Included</li> 
                        <li> <a href="https://www.balihotelsandmore.com/terms-of-use" target="_blank">Free Airport Transfers <span style={{color: 'red'}}>*</span> </a>  </li>
                        <li>Pay In Your Own Currency</li>
                        <li><a href="http://baliholidaysandmorevip.com/" target="_blank">VIP Exclusive Program</a> </li>
                        <li><a href="https://www.balihotelsandmore.com/bali-tours/" target="_blank">Free Tours For Kids </a> </li>
                        <li>Dedicated Customer Live Support</li>
                        <li>Discounted Tours And Activities </li>
                        <li>Discounted Travel Insurance <span style={{color: 'red'}}>*</span></li>
                    </ul>
                }
            />
        );
        let cancelationPolicy = <div>{isiCancelationPolicy}</div>;
        rightPanel.push(
            <ColapsePanel
                title="Cancelation Policies"
                colapse={this.props.collapse}
                component={cancelationPolicy}
            />
        );
        return (
            <div>
                {rightPanel}
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/new-booking/BookingRightPanel.tsx